$(function () {

	var files; // переменная. будет содержать данные файлов


	$(document).on('submit', '.nice-form', function (e) {
		let required = $(this).find('.required'),
			form = $(this),
			err = false;

		required.each(function () {
			let is_checkbox = $(this).attr('type') === 'checkbox';

			if (is_checkbox && !$(this).prop('checked')) {
				err = true;

				$(this).parent().addClass('error');
				$(this).siblings('.input-wrap__error').text("Мы не можем обработать данные без вашего подтверждения");
			}

			if ($(this).val().length === 0 && !is_checkbox) {
				err = true;

				$(this).parent().addClass('error');
				$(this).siblings('.input-wrap__error').text("Не заполнено обязательное поле");
			}
		})

		if (err) {
			return false;
		}

		//$(this).closest('.form-with-success').addClass('success');

		form.addClass("disabled");


		const Data = new FormData();

		$(files).each(function (index, file) {
			Data.append('file', file);
		});
		Data.append('action', 'send_mail');
		Data.append('data', form.serialize());
		grecaptcha.ready(function () {
			grecaptcha.execute('6LduxxAeAAAAANhRifczu4Ay6hzguZRoixQLZdzY', {action: 'submit'}).then(function (token) {
				Data.append('recaptcha_response', token);

				$.ajax({
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					cache: false,
					dataType: 'json',
					processData: false,
					contentType: false,
					data: Data,
					success: function (json) {
						console.log(json);
						if (json.success === false) {
							alert('Ошибка при отправке сообщения');
							return false;
						}

						show_modal(json.data.success);

						$('.modal').addClass("modal-success");
						form.find('input:not([type="hidden"]),textarea').val('').prop('checked', false);

						form.removeClass('disabled');

						remove_file(form.find('.form-file-block'));
					}
				});
			});
		});

		return false;
	});

	$(document).on('click', '.js-close-form-success', function () {
		$(this).closest('.form-with-success').removeClass('success');
	});

	$(document).on('input focus', '.nice-form input, .nice-form textarea', function () {
		$(this).siblings('.input-wrap__error').text("");
		$(this).closest('label').removeClass('error');

	});

	$(document).on('input', '.form-file-block input', function (e) {
		let block = $(this).closest('.form-file-block'),
			fileName = e.target.files[0].name,
			maxSize = 10 * 1024 * 1024, // 10мб
			err = false,
			access = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'];

		let n = fileName.lastIndexOf(".");
		let ext = n > -1 ? fileName.substr(n + 1) : fileName;

		if (e.target.files[0].size > maxSize) {
			alert('Максимальный размер файла 10Мб');
			err = true;
		}
		console.log(ext);

		if (access.indexOf(ext) === -1) {
			alert("Подходящие форматы файла ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx']");
			err = true;
		}

		if (err) {
			let block = $(this).closest('.form-file-block');

			block.find('.form-file-block__filename,.js-remove-file').remove();
			block.find('input').val('');
			block.removeClass("load-file");
			return false;
		}

		block.find('.form-file-block__filename,.js-remove-file').remove();

		block.addClass("load-file");
		block.prepend('<span class="js-remove-file"><span class="cross"></span></span>')
		block.find('label').prepend('<span class="form-file-block__filename">' + fileName + '</span>')

		files = this.files;
	});

	$(document).on('click', '.js-remove-file', function () {
		remove_file($(this).closest('.form-file-block'));
	});

	function remove_file(block) {


		block.find('.form-file-block__filename,.js-remove-file').remove();
		block.find('input').val('');
		block.removeClass("load-file");

		files = false;
	}

});